<template>
  <div class="container">
    <div class="handle-box">
      <el-form :model="queryCondition" ref="queryCondition" label-width="120px" class="searchForm">
        <el-row>
          <el-col :span="24">
            <el-row :gutter="20">
              <!--计划单据编号-->
              <el-col :span="6">
                <el-form-item :label="$t('visitPlan.Number')" prop="msvNo">
                  <el-input v-model.trim="queryCondition.msv.msvNo" clearable style="width:100%"></el-input>
                </el-form-item>
              </el-col>
              <!--拜访年份-->
              <el-col :span="6">
                <el-form-item :label="$t('visitPlan.Year')" prop="Year">
                  <el-date-picker v-model="queryCondition.msv.year" type="year" clearable value-format="yyyy" placeholder="选择年" style="width:100%">
                  </el-date-picker>
                </el-form-item>
              </el-col>
              <!--供应商类型-->
              <el-col :span="6">
                <el-form-item :label="$t('visitPlan.Type')" prop="type">
                  <el-select v-model="queryCondition.type" clearable @change="typeChange" style="width:100%">
                    <el-option :key="index" v-for="(item,index) in typeList" :label="item.chineseValue" :value="item.code"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <!--类型-->
              <el-col :span="6">
                <el-form-item :label="$t('visitPlan.Category')" prop="category">
                  <el-select v-model="queryCondition.category" clearable @change="CategoryChange" style="width:100%">
                    <el-option :key="index" v-for="(item,index) in categoryList" :label="item.NAME" :value="item.NAME"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
          </el-col>
          <el-collapse-transition>
            <el-col :span="24" v-if="isShow">
              <el-row :gutter="20">
                <!--供应商工厂-->
                <el-col :span="6">
                  <el-form-item :label="$t('visitPlan.SupplierFacility')" prop="tmSupplierId">
                    <el-input v-model="queryCondition.supplierName" clearable @clear="clearSupplierName" style="width:100%">
                      <el-button slot="append" icon="el-icon-search" @click="searchSupplier()"></el-button>
                    </el-input>
                  </el-form-item>
                </el-col>
                <!--创建人-->
                <el-col :span="6">
                  <el-form-item :label="$t('visitPlan.CreateUser')">
                    <el-input v-model.trim="queryCondition.creater" clearable style="width:100%">
                      <el-button slot="append" icon="el-icon-search" @click="searchCreateBy()"></el-button>
                    </el-input>
                  </el-form-item>
                </el-col>
                <!--ResponsibleCQS-->
                <el-col :span="6">
                  <el-form-item :label="$t('visitPlan.ResponsibleCQS')" prop="responsibleCqs">
                    <el-input v-model="queryCondition.responsibleCqs" clearable style="width:100%"></el-input>
                  </el-form-item>
                </el-col>
                <!--风险水平-->
                <el-col :span="6">
                  <el-form-item :label="$t('visitPlan.OverallRiskLevel')" prop="riskLevel">
                    <el-select v-model="queryCondition.riskLevel" clearable style="width:100%">
                      <el-option :key="index" v-for="(item,index) in riskLevelList" :label="item.code" :value="item.code"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="20">
                <!--计划状态-->
                <el-col :span="6">
                  <el-form-item :label="$t('visitPlan.PlanStatus')" prop="status">
                    <el-select v-model="queryCondition.msv.status" clearable style="width:100%">
                      <el-option :key="index" v-for="(item,index) in statusList" :label="item.chineseValue" :value="item.code"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <!--计划明细状态-->
                <el-col :span="6">
                  <el-form-item :label="$t('visitPlan.PlanDetailsStatus')" prop="monthStatus">
                    <el-select v-model="queryCondition.monthStatus" clearable style="width:100%">
                      <el-option :key="index" v-for="(item,index) in monthStatusList" :label="item.chineseValue" :value="item.code"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <!--创建时间-->
                <el-col :span="6">
                  <el-form-item label="创建时间(从)" prop="beginDate">
                    <el-date-picker style="width: 100%" v-model="queryCondition.beginDate" type="date" :picker-options="pickerOptionsStart" placeholder="选择日期" value-format="yyyy-MM-dd"></el-date-picker>
                    <!-- <el-date-picker ref="rateDatePk" v-model="queryCondition.dataArr" type="daterange" :range-separator="$t('common.to')" :start-placeholder="$t('common.startDate')" :end-placeholder="$t('common.endDate')" clearable style="width:100%"></el-date-picker> -->
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="创建时间(至)" prop="endDate">
                    <el-date-picker style="width: 100%" v-model="queryCondition.endDate" type="date" :picker-options="pickerOptionsStart" placeholder="选择日期" value-format="yyyy-MM-dd"></el-date-picker>
                    <!-- <el-date-picker ref="rateDatePk" v-model="queryCondition.dataArr" type="daterange" :range-separator="$t('common.to')" :start-placeholder="$t('common.startDate')" :end-placeholder="$t('common.endDate')" clearable style="width:100%"></el-date-picker> -->
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="20">
                <!--备注-->
                <el-col :span="6">
                  <el-form-item :label="$t('visitPlan.Remark')" prop="remark">
                    <el-input v-model.trim="queryCondition.remark" clearable style="width:100%"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-col>
          </el-collapse-transition>
        </el-row>
        <el-row type="flex" justify="center" align="middle">
          <el-button size="mini" @click="search" type="primary">{{$t('common.search')}}</el-button>
          <el-button size="mini" @click="restQueryFormThis" type="primary">{{$t('common.reset')}}</el-button>
          <span class="arrowDown" @click="isShow=!isShow">{{isShow?'收缩':'展开'}}<i :class="isShow?'el-icon-arrow-up iconBtn':'el-icon-arrow-down iconBtn'"></i></span>
        </el-row>
      </el-form>
    </div>
    <div class="action-btn-row">
      <el-button size="mini" class="btn" type="primary" v-acl="MsvAdd" @click="addVisitPlan">{{$t('visitPlan.addVisitPlan')}}</el-button>
      <el-button size="mini" class="btn" type="primary" v-acl="MsvQueryExport" @click="exportList">{{$t('base.linePrice.export')}}</el-button>
    </div>
    <el-table :data="tableList" ref="tableList" border highlight-current-row max-height='450'>
      <el-table-column show-overflow-tooltip prop="msv.year" :label="$t('visitPlan.Year')" min-width="70" fixed>
        <template slot-scope="scope">
          <div class="a-link" @click="toDetail(scope.row)">{{scope.row.msv.year}}</div>
        </template>
      </el-table-column>
      <el-table-column show-overflow-tooltip prop="type" :label="$t('visitPlan.Type')" min-width="80" fixed></el-table-column>
      <el-table-column show-overflow-tooltip prop="category" :label="$t('visitPlan.Category')" min-width="80" fixed></el-table-column>
      <el-table-column show-overflow-tooltip prop="supplierName" :label="$t('visitPlan.SupplierFacility')" min-width="180" fixed></el-table-column>
      <el-table-column show-overflow-tooltip prop="responsibleCqs" :label="$t('visitPlan.ResponsibleCQS')" min-width="100"></el-table-column>
      <el-table-column show-overflow-tooltip prop="riskLevel" :label="$t('visitPlan.OverallRiskLevel')" min-width="70"></el-table-column>
      <el-table-column show-overflow-tooltip prop="frequency" :label="$t('visitPlan.Frequency')" min-width="100"></el-table-column>
      <!--拜访频率-->
      <el-table-column show-overflow-tooltip :formatter="formatStatus" prop="msv.status" :label="$t('visitPlan.PlanStatus')" min-width="80"></el-table-column>
      <el-table-column show-overflow-tooltip prop="remark" :label="$t('visitPlan.Remark')" min-width="80"></el-table-column>
      <el-table-column show-overflow-tooltip label="Month1" min-width="120">
        <el-table-column prop="monthOne" label="月份" min-width="90"></el-table-column>
        <el-table-column prop="msvOneReportNo" label="MSV单据号" min-width="100">
          <template slot-scope="scope">
            <div class="a-link" v-if="scope.row.msvOneReportNo==null && scope.row.msv.status =='SUBMIT' && scope.row.monthOneStatus!='CANCEL'" @click="addVisitReport(scope.row.ttMsvId,scope.row.ttMsvDetailId,1,scope.row)">添加拜访报告</div>
            <div class="a-link" v-else @click="toReportDetail(scope.row.monthOneReportId)">{{scope.row.msvOneReportNo}}</div>
          </template>
        </el-table-column>
        <el-table-column prop="monthOneStatus" :label="$t('visitPlan.PlanDetailsStatus')" min-width="100"><template slot-scope="scope">{{scope.row.monthOneStatus|ic("TT_MSV","VISIT_DETAIL_STATUS")}}</template></el-table-column>
      </el-table-column>
      <el-table-column show-overflow-tooltip label="Month2" min-width="120">
        <el-table-column prop="monthTwo" label="月份" min-width="90"></el-table-column>
        <el-table-column prop="msvTwoReportNo" label="MSV单据号" min-width="100">
          <template slot-scope="scope">
            <div class="a-link" v-if="scope.row.riskLevel=='H' && scope.row.msvTwoReportNo==null && scope.row.monthTwo!=null && scope.row.msv.status =='SUBMIT' && scope.row.monthTwoStatus!='CANCEL'" @click="addVisitReport(scope.row.ttMsvId,scope.row.ttMsvDetailId,2,scope.row)">添加拜访报告</div>
            <div class="a-link" v-else @click="toReportDetail(scope.row.monthTwoReportId)">{{scope.row.msvTwoReportNo}}</div>
          </template>
        </el-table-column>
        <el-table-column prop="monthTwoStatus" :label="$t('visitPlan.PlanDetailsStatus')" min-width="100"><template slot-scope="scope">{{scope.row.monthTwoStatus|ic("TT_MSV","VISIT_DETAIL_STATUS")}}</template></el-table-column>
      </el-table-column>
      <el-table-column show-overflow-tooltip prop="msv.creater" :label="$t('visitPlan.CreateUser')" min-width="120"></el-table-column>
      <el-table-column show-overflow-tooltip prop="createDate" :label="$t('visitPlan.CreateDate')" min-width="100">
        <template slot-scope="scope">{{scope.row.createDate | dateFormatFilter("YYYY-MM-DD")}}</template>
      </el-table-column>
      <el-table-column show-overflow-tooltip prop="msv.updater" :label="$t('visitPlan.UpdateUser')" min-width="90"></el-table-column>
      <el-table-column show-overflow-tooltip prop="updateDate" :label="$t('visitPlan.UpdateDate')" min-width="100">
        <template slot-scope="scope">{{scope.row.updateDate | dateFormatFilter("YYYY-MM-DD")}}</template>
      </el-table-column>
      <el-table-column show-overflow-tooltip prop="msv.msvNo" :label="$t('visitPlan.Number')" min-width="100"></el-table-column>
    </el-table>
    <div class="pagination">
      <!--===分页组件===-->
      <el-pagination @size-change="pageSizeChange" @current-change="pageNumberChange" :current-page="queryCondition.pageNum" :page-sizes="[10,15,50,100]" :page-size="queryCondition.pageSize" :layout="pageLayout" :total="totalCount"></el-pagination>
    </div>
    <el-dialog :visible.sync="showUserDialog" width="80%">
      <PickupUser @input="selectUserData"></PickupUser>
    </el-dialog>
    <el-dialog :visible.sync="showSelSupplierDialog" append-to-body width="80%">
      <SelSupplier :multipleSelectionFlag="true" :supplier-info-only="isHGS" v-if="DestroyIncomeStatistics" ref="supplierSelRef" :categoryLevel1Name='categoryLevel1Name' :categoryLevel2Name='categoryLevel2Name' @subCallMethod="selectSupplierMethod"></SelSupplier>
    </el-dialog>
  </div>
</template>
<script>
import { getVisitPlanList, exportVisitPlan, getCategoryValue, } from "@/api/visitPlan.js";
import PickupUser from "@/components/page/visitPlan/choiceUser";
import { inputChoiceService } from "@/api/common/input-choice";
import commonFunction from "@/utils/dataTableUtils";
import SelSupplier from "@/components/page/visitPlan/supplierFactory";
import { Message } from "element-ui";
import commonFun from "@/utils/commonFun";
import store from '@/store/index';
import paginationMixin from '@/mixins/pagitionMixin';
import { applyService } from "../../../api/quotation-apply/quotation-apply";
export default {
  name: "",
  mixins: [paginationMixin],
  components: { PickupUser, SelSupplier },

  data() {
    return {
      isShow: false,//控制查询列表收缩展开
      categoryLevel1Name: '',
      categoryLevel2Name: '',
      totalCount: 0,
      tableList: [],
      typeList: [],
      categoryList: [],
      queryCondition: {
        category: '',
        riskLevel: '',
        pageSize: 15,
        pageNum: 1,
        msv: {
          msvNo: '',
          year: '',
          status: '',
        },
        responsibleCqs: '',
        creater: '',
        supplierCode: '',
        supplierName: '',
        monthStatus: '',
        type: '',
        remark: '',
        beginDate: "",
        endDate: "",
        // dataArr: [],
      },
      statusList: [],
      monthStatusList: [],
      quotationStatusList: [],
      quotationTypeList: [],
      applyTypeList: [],
      riskLevelList: [],
      radioVal: null,
      selectRow: null,
      showUserDialog: false,
      showSelSupplierDialog: false,
      categoryLevel1Name: '',
      categoryLevel2Name: '',
      DestroyIncomeStatistics: false,
      username: '',
      SuperAdmin: false,
      isHGS: false,
      functionCodes: [],
    };
  },
  watch: {
    queryCondition() {
      let _this = this;
      store.dispatch('uploadListParams', { routeName: _this.$route.name, reqData: _this.queryCondition })
    },
  },
  computed: {
    functions() {
      return this.$store.state.main.functions;
    },
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.queryCondition = to.meta.reqData;
      vm.username = localStorage.getItem("ms_username");
      let permission = JSON.parse(localStorage.getItem("ms_Permission"));
      if (commonFun.havePermission('IS_HGS')) {
        vm.isHGS = true;
      }
      for (let i = 0, len = permission.length; i < len; i++) {
        if (permission[i] == 'MSV_ADMIN') {//超级管理员
          vm.SuperAdmin = true;
        }
      }
      vm.search();
    })
  },
  created() {
    console.log('functionCodes', localStorage.getItem("ms_Permission"));
    // console.log('functions', JSON.parse(localStorage.getItem("ms_Permission")));
    // if (JSON.parse(this.functions) && JSON.parse(this.functions).length !== 0) {
    //   this.functionCodes = JSON.parse(this.functions);
    // } else {
    //   }
    this.functionCodes = JSON.parse(localStorage.getItem("ms_Permission"));
    this.getInputChoiceValues();
  },
  methods: {
    typeChange(val) {
      this.categoryLevel1Name = val
      this.categoryLevel2Name = ''
      this.queryCondition.supplierCode = ''
      this.queryCondition.supplierName = ''
      this.queryCondition.tmSupplierIds = []
      this.DestroyIncomeStatistics = false;//为了重新渲染子组件
      if (val == 'Food') {
        this.getCategory(val)
      } else {
        this.categoryList = []
        this.queryCondition.category = ''
      }
    },
    CategoryChange(val) {
      this.categoryLevel2Name = val
      this.queryCondition.supplierCode = ''
      this.queryCondition.supplierName = ''
      this.queryCondition.tmSupplierIds = []
      this.DestroyIncomeStatistics = false;//为了重新渲染子组件
    },
    //动态获取Category下拉框的值
    getCategory(value) {
      let that = this;
      let data = {
        categoryLevel1Name: value
      }
      getCategoryValue(data).then(res => {
        this.categoryList = res.data
      });
    },
    search() {
      // this.queryCondition.pageNum = 1
      // this.queryCondition.pageSize = 15
      this.queryData()
    },
    queryData() {
      // let dataValue = that.queryCondition.dataArr;
      // (this.queryCondition.beginDate = !!dataValue
      //   ? this.$options.filters["dateFormatFilter"](dataValue[0])
      //   : ""),
      //   (this.queryCondition.endDate = !!dataValue
      //     ? this.$options.filters["dateFormatFilter"](dataValue[1])
      //     : ""),
      getVisitPlanList(this.queryCondition).then(res => {
        this.tableList = res.resultData;
        this.totalCount = res.totalCount;
      });
    },
    toReportDetail(id) {
      let resolve = this.$router.resolve({
        path: `/visitReport-add`,
        query: { ttMsvReportId: id, VisitPlanIN: true }
      });
      window.open(resolve.href, "_blank");
    },
    toDetail(row) {
      //权限检查
      // if (this.actionCheck.actionCheck('MsvQueryDetail') === false) {
      //   this.$message.error(this.$t('common.noPermission'))
      //   return false
      // }
      console.log('functionCodes', this.functionCodes);
      if (this.functionCodes.indexOf('MsvQueryDetail') == -1) {
        this.$message.error(this.$t('common.noPermission'))
        return false
      }
      const route = this.$router.resolve({
        path: `/visitPlan-add`,
        query: {
          ttMsvId: row.ttMsvId,
          month1: row.msvOneReportNo,
          month2: row.msvTwoReportNo,
        }
      });
      window.open(route.href, '_blank')
    },
    addVisitReport(ttMsvId, ttMsvDetailId, num, row) {
      let that = this
      let month = ''
      if (num == 1) {
        month = 'ONE'
      }
      if (num == 2) {
        month = 'TWO'
      }
      let status = row.msv.status
      //拜访计划状态=提交，只有一条明细行，并且该明细行已经Inactive了，应该控制不能添加拜访报告 或者 不显示添加拜访报告
      if (this.actionCheck.actionCheck('Msv-reportAdd') === false) {
        this.$message.error(this.$t('common.noPermission'))
        return false

      }
      if (that.SuperAdmin) {//如果是超级管理员
        that.$router.push({
          path: `/visitReport-add`,
          query: { ttMsvId: ttMsvId, ttMsvDetailId: ttMsvDetailId, month: month, VisitPlanIN: true }
        });
      } else {
        if (that.username == row.msvCreater) {
          that.$router.push({
            path: `/visitReport-add`,
            query: { ttMsvId: ttMsvId, ttMsvDetailId: ttMsvDetailId, month: month, VisitPlanIN: true }
          });
        } else if (that.username != row.msvCreater) {
          that.$message({
            type: "error",
            message: '只能对自己创建的拜访计划进行操作'
          });
        }
      }

    },
    searchSupplier() {
      this.$nextTick(() => {
        this.DestroyIncomeStatistics = true;
      });
      this.showSelSupplierDialog = true
    },
    searchCreateBy() {
      this.showUserDialog = true
    },
    selectUserData(name, id) {
      this.queryCondition.creater = name
      // this.queryCondition.createBy = id
      this.showUserDialog = false
    },
    selectSupplierMethod: function (supList) {
      let that = this
      that.queryCondition.tmSupplierIds = [];
      that.queryCondition.supplierCode = '';
      supList.forEach((item) => {
        that.queryCondition.tmSupplierIds.push(item.tmSupplierId);
        that.queryCondition.supplierCode = that.queryCondition.supplierCode + item.supplierCode + ',';
      });
      that.queryCondition.supplierCode = supList.map(sup => sup.supplierCode).join(',');
      that.queryCondition.supplierName = supList.map(sup => sup.supplierName).join(',');
      that.showSelSupplierDialog = false;
    },
    querySearch(queryString, cb) {
      var restaurants = this.categoryList;
      restaurants = restaurants.map(obj => {
        return {
          ...obj,
          value: obj.chineseValue
        }
      })
      var results = queryString ? restaurants.filter(this.createFilter(queryString)) : restaurants;
      cb(results);
    },
    createFilter(queryString) {
      return (restaurant) => {
        return (restaurant.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
      };
    },
    //查询条件重置方法
    restQueryFormThis: function () {
      this.$refs.queryCondition.resetFields();
      this.queryCondition.tmSupplierIds = []
      this.categoryLevel1Name = ''
      this.categoryLevel2Name = ''
      this.queryCondition = {
        category: '',
        riskLevel: '',
        pageSize: 15,
        pageNum: 1,
        msv: {
          msvNo: '',
          year: '',
          status: '',
        },
        responsibleCqs: '',
        creater: '',
        supplierCode: '',
        supplierName: '',
        monthStatus: '',
        type: '',
        remark: '',
        beginDate: "",
        endDate: "",
      }
      this.DestroyIncomeStatistics = false;//为了重新渲染子组件
      this.queryData()
    },
    //页码变化
    pageNumberChange(val) {
      this.queryCondition.pageNum = val;
      this.queryData();
    },
    //显示条数变更
    pageSizeChange(val) {
      this.queryCondition.pageSize = val;
      this.queryData();
    },
    addVisitPlan() {
      this.$router.push({
        path: `/visitPlan-add`
      });
    },
    exportList() {
      exportVisitPlan(this.queryCondition).then(res => {
        if (window.navigator.msSaveBlob) {
          try {
            let data = new Blob([res])
            window.navigator.msSaveBlob(data, "拜访计划.xls");
          } catch (e) {
            this.$message({ type: 'error', message: '文件下载失败' });
          }
        } else {
          try {
            const link = document.createElement("a");
            console.log(res)
            let blob = new Blob([res], { type: res.type });
            link.style.display = "none";
            link.href = URL.createObjectURL(blob); //创建下载的链接
            link.setAttribute("download", "拜访计划.xls"); //下载后文件名
            document.body.appendChild(link);
            link.click(); //模拟在按钮上的一次鼠标单击
            document.body.removeChild(link); //释放URL 对象
          } catch (e) {
            this.$message({
              type: "error",
              message: this.$t("base.linePrice.fileDownloadError")
            });
          }
        }

      });
    },
    //清除校验信息
    clearVlidate: function (refFormName) {
      if (this.$refs[refFormName]) {
        this.$refs[refFormName].clearValidate();
      }
    },
    clearSupplierName() {
      this.queryCondition.supplierCode = "";
      this.queryCondition.tmSupplierIds = []
    },
    formatStatus: function (row, column) {
      return row.msv.status == "DRAFT" ? "草稿" : row.msv.status == "SUBMIT" ? "提交" : "";
    },
    //单选操作
    getSelectRow: function (row) {
      this.selectRow = [];
      this.selectRow = row;
    },
    getInputChoiceValues() {
      let that = this
      let mapObj = {};
      mapObj["TT_MSV:TYPE"] = "TT_MSV:TYPE";
      mapObj["TT_MSV:CATEGORYTYPE"] = "TT_MSV:CATEGORYTYPE";
      mapObj["TT_MSV:RISK_LEVEL"] = "TT_MSV:RISK_LEVEL";
      mapObj["TT_MSV:VISIT_STATUS"] = "TT_MSV:VISIT_STATUS";
      mapObj["TT_MSV:VISIT_DETAIL_STATUS"] = "TT_MSV:VISIT_DETAIL_STATUS";
      inputChoiceService.getInputChoiceValues(mapObj).then(res => {
        let typeList = res["TT_MSV:TYPE"];
        if (that.isHGS) {
          for (let i = 0, len = typeList.length; i < len; i++) {
            if (typeList[i].chineseValue == "Package") {
              that.typeList = [typeList[i]]
            }
          }
        } else {
          that.typeList = typeList
        }
        that.riskLevelList = res["TT_MSV:RISK_LEVEL"];
        that.statusList = res["TT_MSV:VISIT_STATUS"];
        that.monthStatusList = res["TT_MSV:VISIT_DETAIL_STATUS"];
      });
    },
    openSoucingInfo: function (sourcingNo) {
      this.$router.push({
        path: "/sourcing-detail",
        query: { sourcingNo: sourcingNo }
      });
    }
  },
  extends: commonFunction
};
</script>
<style lang="scss">
.visitPlanList {
  .el-form-item__content {
    width: 220px;
  }
  .el-select {
    width: 100%;
  }
  .el-date-editor {
    width: 220px !important;
  }
}
// .visitPlanList{
//   .el-form-item__content {
//     width: 220px;
//   }
//   .el-select {
//     width: 220px;
//   }
//   .el-date-editor {
//     width: 220px;
//   }
//   .el-input{
//     width: 220px;
//   }
// }
</style>
